import React from 'react';

interface ICustomLegendProps {
  color: string;
  title: string;
  additionalValues?: { title: string; color: string }[];
}
export const MultiChartCustomLegend: React.FC<ICustomLegendProps> = ({ color, title, additionalValues = [] }) => (
  <div className="flex gap-3 text-sm">
    {[{ title, color }, ...additionalValues].map((item, index) => (
      <div key={index} className="flex items-center gap-2">
        <div className="w-5 h-1" style={{ background: item.color }}></div>
        <div>{item.title}</div>
      </div>
    ))}
  </div>
);
